import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';
import { bool } from 'aws-sdk/clients/signer';
import { MatSnackBar } from '@angular/material';
import { CommonService } from '../../shared/common.service';

@Component({
  selector: 'app-editp',
  templateUrl: './editp.component.html',
  styleUrls: ['./editp.component.scss']
})
export class EditpComponent implements OnInit {
 
  // loginForm: FormGroup;
 signForm: FormGroup;
 isLogin:boolean = true;
 minDate = new Date();
 formSubmitted: boolean = false;
 errorMsg: string = "Ok";
 headers = [];
 Loginmessage: string = "";
 isLoading: boolean = false;
 isValid:boolean;
 other:any;
 emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

 constructor(private fb: FormBuilder,
   private commonService: CommonService,
   private router: Router,
   private _snackBar: MatSnackBar,) { }

 ngOnInit() {
   this.initialiseForms();
 }
 // initialiseForms() {
 //   this.loginForm = this.fb.group({
 //     name: ["", [Validators.required]],
 //     type: ["", [Validators.required]],
 //     date: ["", [Validators.required]],
 //     location: ["", [Validators.required]],
 //     bio: ["", [Validators.required]],
 //     refcode: ["", [Validators.required]],
 //   });
 // }



 loginFN() {
   this.router.navigate(['main/upload-video'])
 }
 SwitchLogin(value){
   if (value == 'true') {
     this.isLogin = true;
   }else {
     this.isLogin = false;
   }

 }


initialiseForms() {
 this.signForm = this.fb.group({
       companyName: ["", [Validators.required]],
       email: ["", [Validators.required,Validators.pattern(this.emailPattern)]],
       password: ["", [Validators.required,Validators.minLength(6)]],
       companyType: ["", [Validators.required]],
       dateEstablished: ["", [Validators.required]],
       location: ["", [Validators.required]],
       bio: ["", [Validators.required]],
       inviteCode: ["", [Validators.required]],
       role: ["C", [Validators.required]],
       userType: ["web", [Validators.required]],

     });
} 





}
